import clsx from "clsx"
import { NpIcon } from "src/components/np-design/components/NpIcon"
import { TimeRestrictedContent } from "src/components/unstyled/TimeRestrictedContent"
import { interpretAsGermanTimeIso } from "src/utilities/germanTime"

const startOfBreak = interpretAsGermanTimeIso("2024-12-20T09")
const endOfBreak = interpretAsGermanTimeIso("2025-01-04")

export type ShippingTimeProps = {
  fulfillmentFrom: string | undefined
  showIcon?: boolean
}

export const ShippingTime = ({ fulfillmentFrom, showIcon }: ShippingTimeProps) => {
  return (
    <div
      className={clsx("flex items-center gap-2 leading-tight text-pretty", {
        "text-np-green": !fulfillmentFrom,
        "text-np-gray75": fulfillmentFrom,
      })}
    >
      {fulfillmentFrom ? (
        <div className="mx-auto flex items-center gap-2 text-left leading-tight">
          <NpIcon name="package" />
          <div>Lieferbar ab {fulfillmentFrom}</div>
        </div>
      ) : (
        <>
          {showIcon && <NpIcon name="package" className="-my-4 size-8" />}
          <TimeRestrictedContent end={startOfBreak}>
            <div>In 1-3 Werktagen bei dir (DE)</div>
          </TimeRestrictedContent>
          <TimeRestrictedContent start={startOfBreak} end={endOfBreak}>
            <div>Ab dem 7. Januar wieder lieferbar</div>
          </TimeRestrictedContent>
          <TimeRestrictedContent start={endOfBreak}>
            <div>In 1-3 Werktagen bei dir (DE)</div>
          </TimeRestrictedContent>
        </>
      )}
    </div>
  )
}
